
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vlog",
      function () {
        return require("private-next-pages/vlog/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vlog"])
      });
    }
  